import React from 'react';
import { TeamModal } from './TeamModal';
import { CreateTeamData } from '../../types';

interface CreateTeamModalProps {
  opened: boolean;
  onClose: () => void;
  onSubmit: (teamData: CreateTeamData) => void;
  loading?: boolean;
}

export const CreateTeamModal: React.FC<CreateTeamModalProps> = ({
  opened,
  onClose,
  onSubmit,
  loading = false,
}) => {
  return <TeamModal opened={opened} onClose={onClose} onSubmit={onSubmit} loading={loading} />;
};
